import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { TAB_BOX_CONVERTER_TOKEN, TabBoxConverter } from './tab-box.component.converter'
import { TAB_BOX_ITEM_CONVERTER_TOKEN, TabBoxItemConverter } from './tab-box-item/tab-box-item.component.converter'
import {
  TAB_BOX_HEADER_TEXT_CONVERTER_TOKEN, TabBoxHeaderTextConverter
} from './tab-box-item/tab-box-header-text/tab-box-header-text.component.converter'
import { TIMELINE_CONVERTER_TOKEN, TimelineConverter } from './tab-box-item/timeline/timeline.component.converter'
import {
  TIMELINE_ITEM_CONVERTER_TOKEN, TimelineItemConverter
} from './tab-box-item/timeline/timeline-item/timeline-item.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        tabBoxFeature: {
          module: () => import('./tab-box.module').then((m) => m.TabBoxModule),
          cmsComponents: ['tab_box']
        },
      }
    }),
    {
      provide: TAB_BOX_CONVERTER_TOKEN,
      useExisting: TabBoxConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        tab_box: TAB_BOX_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: TAB_BOX_ITEM_CONVERTER_TOKEN,
      useClass: TabBoxItemConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        tab_box_item: TAB_BOX_ITEM_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: TAB_BOX_HEADER_TEXT_CONVERTER_TOKEN,
      useClass: TabBoxHeaderTextConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        tab_box_header_text: TAB_BOX_HEADER_TEXT_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: TIMELINE_CONVERTER_TOKEN,
      useClass: TimelineConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        time_line: TIMELINE_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: TIMELINE_ITEM_CONVERTER_TOKEN,
      useClass: TimelineItemConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        time_line_item: TIMELINE_ITEM_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class TabBoxFeatureModule {}
